import { produce } from 'immer';

import { FoodTrayTemplate } from '../../models';
import { ActionType } from './types';

export interface IDepartment {
  id: string;
  name: string;
}

export interface FoodTrayTemplatesState {
  all: FoodTrayTemplate[];
  one: FoodTrayTemplate | null;
  isLoading: boolean;
  isDuplicateLoading: boolean;
  isCreateLoading: boolean;
  isUpdateLoading: boolean;
  isDeleteLoading: boolean;
  isReplaceFoodItemLoading: boolean;
  isReplaceFoodItemAndStartTimerLoading: boolean;
  isEmptyItemLoading: boolean;
  isEmptyLineLoading: boolean;
  isStartTimerLoading: boolean;
  isStartTimerForExistingFoodItemLoading: boolean;
  serverError: string;
}

const initialState = {
  all: [],
  one: null,
  isLoading: false,
  isDuplicateLoading: false,
  isDeleteLoading: false,
  isReplaceFoodItemLoading: false,
  isReplaceFoodItemAndStartTimerLoading: false,
  isEmptyItemLoading: false,
  isEmptyLineLoading: false,
  isStartTimerLoading: false,
  isStartTimerForExistingFoodItemLoading: false,
  serverError: null,
};

const FoodTrayTemplates = produce((draft: FoodTrayTemplatesState, action) => {
  const { payload, error } = action;
  switch (action.type) {
    case ActionType.GET_FOOD_TRAY_TEMPLATES:
      draft.isLoading = true;
      break;
    case ActionType.GET_FOOD_TRAY_TEMPLATES_FULFILLED:
      draft.isLoading = false;
      draft.all = payload?.data;
      break;
    case ActionType.GET_FOOD_TRAY_TEMPLATES_REJECTED:
      draft.serverError = error.message;
      draft.isLoading = false;
      break;
    case ActionType.GET_FOOD_TRAY_TEMPLATE:
      draft.isLoading = true;
      break;
    case ActionType.GET_FOOD_TRAY_TEMPLATE_FULFILLED:
      draft.isLoading = false;
      draft.one = payload?.data;
      break;
    case ActionType.GET_FOOD_TRAY_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isLoading = false;
      break;
    case ActionType.CLEAR_FOOD_TRAY_TEMPLATE:
      draft.one = null;
      break;
    case ActionType.DUPLICATE_FOOD_TRAY_TEMPLATE:
      draft.isDuplicateLoading = true;
      break;
    case ActionType.DUPLICATE_FOOD_TRAY_TEMPLATE_FULFILLED:
      draft.isDuplicateLoading = false;
      break;
    case ActionType.DUPLICATE_FOOD_TRAY_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isDuplicateLoading = false;
      break;
    case ActionType.CREATE_FOOD_TRAY_TEMPLATE:
      draft.isCreateLoading = true;
      break;
    case ActionType.CREATE_FOOD_TRAY_TEMPLATE_FULFILLED:
      draft.isCreateLoading = false;
      break;
    case ActionType.CREATE_FOOD_TRAY_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isCreateLoading = false;
      break;
    case ActionType.UPDATE_FOOD_TRAY_TEMPLATE:
      draft.isUpdateLoading = true;
      break;
    case ActionType.UPDATE_FOOD_TRAY_TEMPLATE_FULFILLED:
      draft.isUpdateLoading = false;
      break;
    case ActionType.UPDATE_FOOD_TRAY_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isUpdateLoading = false;
      break;
    case ActionType.DELETE_FOOD_TRAY_TEMPLATE:
      draft.isDeleteLoading = true;
      break;
    case ActionType.DELETE_FOOD_TRAY_TEMPLATE_FULFILLED:
      draft.isDeleteLoading = false;
      break;
    case ActionType.DELETE_FOOD_TRAY_TEMPLATE_REJECTED:
      draft.serverError = error.message;
      draft.isDeleteLoading = false;
      break;
    case ActionType.REPLACE_FOOD_ITEM:
      draft.isReplaceFoodItemLoading = true;
      break;
    case ActionType.REPLACE_FOOD_ITEM_AND_START_TIMER:
      draft.isReplaceFoodItemAndStartTimerLoading = true;
      break;
    case ActionType.EMPTY_ITEM:
      draft.isEmptyItemLoading = true;
      break;
    case ActionType.EMPTY_LINE:
      draft.isEmptyLineLoading = true;
      break;
    case ActionType.START_TIMER:
      draft.isStartTimerLoading = true;
      break;
    case ActionType.START_TIMER_FOR_EXISTING_FOOD_ITEM:
      draft.isStartTimerForExistingFoodItemLoading = true;
      break;
    case ActionType.REPLACE_FOOD_ITEM_FULFILLED:
      draft.isReplaceFoodItemLoading = false;
      break;
    case ActionType.REPLACE_FOOD_ITEM_AND_START_TIMER_FULFILLED:
      draft.isReplaceFoodItemAndStartTimerLoading = false;
      break;
    case ActionType.EMPTY_ITEM_FULFILLED:
      draft.isEmptyItemLoading = false;
      break;
    case ActionType.EMPTY_LINE_FULFILLED:
      draft.isEmptyLineLoading = false;
      break;
    case ActionType.START_TIMER_FULFILLED:
      draft.isStartTimerLoading = false;
      break;
    case ActionType.START_TIMER_FOR_EXISTING_FOOD_ITEM_FULFILLED:
      draft.isStartTimerForExistingFoodItemLoading = false;
      break;
    case ActionType.REPLACE_FOOD_ITEM_REJECTED:
      draft.isReplaceFoodItemLoading = false;
      draft.serverError = error.message;
      break;
    case ActionType.REPLACE_FOOD_ITEM_AND_START_TIMER_REJECTED:
      draft.isReplaceFoodItemAndStartTimerLoading = false;
      draft.serverError = error.message;
      break;
    case ActionType.EMPTY_ITEM_REJECTED:
      draft.isEmptyItemLoading = false;
      draft.serverError = error.message;
      break;
    case ActionType.EMPTY_LINE_REJECTED:
      draft.isEmptyLineLoading = false;
      draft.serverError = error.message;
      break;
    case ActionType.START_TIMER_REJECTED:
      draft.isStartTimerLoading = false;
      draft.serverError = error.message;
      break;
    case ActionType.START_TIMER_FOR_EXISTING_FOOD_ITEM_REJECTED:
      draft.isStartTimerForExistingFoodItemLoading = false;
      draft.serverError = error.message;
      break;
    default:
      break;
  }
}, initialState);

export default FoodTrayTemplates;
